import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es-es/*")({
  head: () => buildRouteHead("/es-es/*", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es", replace: true });
  },
});
